import { render } from "./AnnotationEditorGallery.vue?vue&type=template&id=72a2babb&scoped=true"
import script from "./AnnotationEditorGallery.vue?vue&type=script&lang=js"
export * from "./AnnotationEditorGallery.vue?vue&type=script&lang=js"

import "./AnnotationEditorGallery.vue?vue&type=style&index=0&id=72a2babb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a2babb"]])

export default __exports__